import type { PageTour } from '../types';

export const dashboardTour: PageTour = {
  id: 'dashboard',
  label: 'Dashboard Tour',
  steps: [
    {
      target: 'body',
      content: 'Welcome to Dynamatix! Let\'s take a quick tour to help you get started.',
      placement: 'center',
      title: 'Welcome!',
    },
    {
      target: '[data-tour="sidebar-nav"]',
      content: 'This is your main navigation. Everything is organized by category — Work, Management, Analytics, and more.',
      title: 'Sidebar Navigation',
    },
    {
      target: '[data-tour="dashboard-grid"]',
      content: 'Your dashboard shows key metrics at a glance — hours logged, allocation, active projects, and milestones.',
      title: 'Dashboard Overview',
    },
    {
      target: '[data-tour="quick-actions"]',
      content: 'Use these buttons for common tasks like creating a new project or opening training modules.',
      title: 'Quick Actions',
    },
    {
      target: '[data-tour="search-bar"]',
      content: 'Search for people, projects, knowledge articles, and news all from one place.',
      title: 'Search Bar',
    },
    {
      target: '[data-tour="sidebar-timesheet"]',
      content: 'Log your daily work hours here. You can also use the Quick Log feature from the dashboard.',
      title: 'Timesheet',
    },
    {
      target: '[data-tour="sidebar-leave"]',
      content: 'Apply for leave and check your leave balance. Your manager will be notified automatically.',
      title: 'Leave Management',
    },
    {
      target: '[data-tour="help-button"]',
      content: 'Need help? Click here anytime to get context-specific help for any page.',
      title: 'Help Button',
    },
    {
      target: 'body',
      content: 'You\'re all set! You can replay this tour anytime from the \'Start Tour\' option in your account menu.',
      placement: 'center',
      title: 'Tour Complete!',
    },
  ],
};
